import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { IPartnerContactFormValues } from "src/entities/partners/model/types";
import { useGetPartnerDropdownsQuery } from "src/shared/api/dropdowns/partner";
import { SelectField } from "src/shared/components";

export const ContactCriteriaInfo: FC = () => {
  const { control } = useFormContext<IPartnerContactFormValues>();
  const { data: dropdowns } = useGetPartnerDropdownsQuery();
  const {
    partner_person_technical_knowledge_level,
    partner_person_loyalty_level,
    partner_person_emotional_level,
    partner_person_personality_type,
  } = dropdowns || {};

  return (
    <Stack spacing={4}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            color: "grey.500",
            fontSize: "0.875rem",
            ml: 2,
          }}
        >
          Тех.грамотность
        </Typography>
        <Box
          sx={{
            width: 250,
          }}
        >
          <Controller
            control={control}
            name="technical_knowledge_level"
            render={({ field: { ref, ...field }, fieldState: { error } }) => (
              <SelectField
                inputRef={ref}
                fullWidth
                {...field}
                error={!!error}
                helperText={error?.message}
                options={partner_person_technical_knowledge_level}
              />
            )}
          />
        </Box>
      </Stack>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            color: "grey.500",
            fontSize: "0.875rem",
            ml: 2,
          }}
        >
          Лояльность
        </Typography>
        <Box
          sx={{
            width: 250,
          }}
        >
          <Controller
            control={control}
            name="loyalty_level"
            render={({ field: { ref, ...field }, fieldState: { error } }) => (
              <SelectField
                inputRef={ref}
                fullWidth
                {...field}
                error={!!error}
                helperText={error?.message}
                options={partner_person_loyalty_level}
              />
            )}
          />
        </Box>
      </Stack>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            color: "grey.500",
            fontSize: "0.875rem",
            ml: 2,
          }}
        >
          Адекватность
        </Typography>
        <Box
          sx={{
            width: 250,
          }}
        >
          <Controller
            control={control}
            name="emotional_level"
            render={({ field: { ref, ...field }, fieldState: { error } }) => (
              <SelectField
                inputRef={ref}
                fullWidth
                {...field}
                error={!!error}
                helperText={error?.message}
                options={partner_person_emotional_level}
              />
            )}
          />
        </Box>
      </Stack>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            color: "grey.500",
            fontSize: "0.875rem",
            ml: 2,
          }}
        >
          Тип личности
        </Typography>
        <Box
          sx={{
            width: 250,
          }}
        >
          <Controller
            control={control}
            name="personality_type"
            render={({ field: { ref, ...field }, fieldState: { error } }) => (
              <SelectField
                inputRef={ref}
                fullWidth
                {...field}
                error={!!error}
                helperText={error?.message}
                options={partner_person_personality_type}
              />
            )}
          />
        </Box>
      </Stack>
    </Stack>
  );
};
